import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import { getParamsFromQueryString } from '../../utils/url'

import {
  formContainer,
  titleContainer,
  mainTitle,
  buttonContainer
} from './styles/LoginForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

import * as validators from '../../utils/validators'
import * as normalizers from '../../utils/normalizers'
import { Box, CircularProgress, Modal, Typography } from '@material-ui/core'
import { modal, closeBtn } from './styles/SignUpForm.style'
import CloseIcon from '@material-ui/icons/Close'
import { getCurrentAppData } from '../../utils/fractalApps'
import { allowedAppIds, isStaging } from '../../utils/constants'

const SignUpForm = ({
  handleSubmit,
  onSubmit,
  isSubmitting,
  translation,
  lang,
  isSuccess
}) => {
  const { email: emailValue, app_id: appId } = getParamsFromQueryString()
  const register = appId === '33' ? 'Registar' : translation('register')['registerTitle']
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const passwordConfirmation = lang === 'pt-BR' ? validators.passwordConfirmatioPT : validators.passwordConfirmatioES
  const passwordLength = lang === 'pt-BR' ? validators.passwordLengthPT : validators.passwordLengthES
  const email = lang === 'pt-BR' ? validators.emailPT : validators.emailES
  const fullnameLength = lang === 'pt-BR' ? validators.fullnameLengthPT : validators.fullnameLengthES
  const validFullname = lang === 'pt-BR' ? validators.validFullnamePT : validators.validFullnameES
  const noSpecialChars = lang === 'pt-BR' ? validators.noSpecialCharsPT : validators.noSpecialCharsES
  const phoneValidation = lang === 'pt-BR' ? validators.phoneValidationBR : validators.phoneValidationPAR
  const normalizePhone = lang === 'pt-BR' ? normalizers.normalizePhoneBRA : normalizers.normalizePhonePAR

  // array of applicationIds
  const showOpenExamFields = ['38', '40', '41']
  const [open, setOpen] = useState(false)
  const appData = getCurrentAppData()
  const handleClose = () => {
    setOpen(false)
    window.location.href = appData.redirectUrl
  }
  const [isDisabled, setIsDisabled] = useState(true)
  const handleRegisterButton = () => {
    if (!isStaging && allowedAppIds.includes(appId)) {
      setOpen(true)
    }
  }

  useEffect(() => {
    if (isSuccess && !isSubmitting) {
      window.location.href = appData.redirectUrl
    }
  }, [isSuccess, isSubmitting])

  const checkInputs = () => {
    const inputs = document.querySelectorAll('input')
    let isAllFilled = true
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].value === '') {
        isAllFilled = false
        break
      }
    }
    setIsDisabled(!isAllFilled)
  }

  return (
    <form
      id='signUpForm'
      className={formContainer}
      onSubmit={handleSubmit(onSubmit)}
    >
      <header className={titleContainer}>
        <h1 className={mainTitle}>{register}</h1>
      </header>

      <div>
        <div>
          <Field
            id='fullname'
            name='name'
            placeholder={translation('register')['namePlaceholder']}
            type='text'
            onChange={checkInputs}
            validate={[
              required,
              noSpecialChars,
              fullnameLength,
              validFullname
            ]}
            normalizers={[normalizers.normalizeFullname]}
            component={Input}
            block
          />
        </div>

        <div>
          <Field
            id='email'
            name='email'
            onChange={checkInputs}
            placeholder={translation('register')['emailPlaceholder']}
            type='email'
            block
            validate={[required, email]}
            component={Input}
            disabled={Boolean(emailValue)}
          />
        </div>

        {showOpenExamFields.includes(appId) && (<>
          <div>
            <Field
              id='city'
              name='additional_data.address.city'
              placeholder={translation('editUserForm')['cityLabel']}
              type='text'
              component={Input}
              validate={[
                required
              ]}
              normalizers={[normalizers.normalizeFullname]}
              block
            />
          </div>
          <div>
            <Field
              id='state'
              name='additional_data.address.state'
              placeholder={translation('editUserForm')['stateLabel']}
              type='text'
              component={Input}
              validate={[
                required
              ]}
              normalizers={[normalizers.normalizeFullname]}
              block
            />
          </div>
          <div>
            <Field
              id='phone'
              name='phone'
              placeholder={translation('editUserForm')['phoneLabel']}
              type='text'
              component={Input}
              validate={[required, phoneValidation]}
              normalizers={[normalizePhone]}
              block
            />
          </div>
        </>)}
        <div>
          <Field
            name='password'
            placeholder={translation('register')['passwordPlaceholder']}
            type='password'
            block
            validate={[required, passwordLength]}
            component={Input}
            onChange={checkInputs}
          />
        </div>

        <div>
          <Field
            name='passwordConfirmation'
            placeholder={translation('register')['confirmPasswordPlaceholder']}
            type='password'
            block
            validate={[required, passwordConfirmation]}
            component={Input}
            onChange={checkInputs}
          />
        </div>
      </div>

      <div className={buttonContainer}>
        <Button
          type='submit'
          disabled={isSubmitting || isDisabled}
          onClick={handleRegisterButton}
        >
          {register}
          {isSubmitting ? <CircularProgress size={20} style={{ color: 'white', marginLeft: 10 }} /> : ''}
        </Button>
      </div>
      {
        (!isStaging && isSuccess && allowedAppIds.includes(appId)) ? (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'
          >
            <Box className={modal}>
              <Button className={closeBtn}
                onClick={handleClose}
              >
                <CloseIcon className={closeBtn} />
              </Button>
              <Typography id='modal-modal-title' variant='h6' component='h2'>
                Confirmação de Email:
              </Typography>
              <Typography id='modal-modal-description'>
                Verifique seu email para confirmação de cadastro.
              </Typography>
            </Box>
          </Modal>
        ) : ''
      }

    </form>
  )
}

SignUpForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  translation: PropTypes.func.isRequired,
  isSuccess: PropTypes.bool,
  lang: PropTypes.string.isRequired
}

const mapStateToProps = ({ auth }) => {
  const { email: emailValue } = getParamsFromQueryString()
  return ({
    isSubmitting: auth.isFetching,
    isSuccess: auth.isSuccess,
    initialValues: emailValue ? { email: emailValue } : { email: '' }
  })
}

const enhance = compose(
  connect(mapStateToProps),
  reduxForm({
    form: 'signUp'
  })
)

export default enhance(SignUpForm)
